<script>
    import axios from "axios";
    import Playlist from "../../components/shared/Playlist";
    import RoundImageWithDefault from "@songfinch/shared/components/RoundImageWithDefault";
    import "@songfinch/customer/stylesheets/includes/helpers/text-underline-on-hover.pcss";
    import {map} from "lodash-es";
    import analyticsEvent from "@songfinch/shared/helpers/analyticsEvent";

    export default {
        name: "PlaylistSingle",
        components: {Playlist, RoundImageWithDefault},
        data() {
            return {
                playlist: null,
                sliderOptions: {
                    perPage: 4,
                    breakpoints: {
                        1199: {
                            perPage: 2,
                        }
                    }
                }
            };
        },
        computed: {
            songs() {
                return map(this.playlist?.songs, song => ({
                    image: song.artist_image,
                    name: song.artist_name,
                    link: this.$router.resolve({name: "ArtistSingle", params: {id: song.artist_id}}).href,
                    audio: song.audio_url,
                    genres: song.genres,
                    occasions: song.occasions,
                    song_subtitle: song.genres.concat(song.occasions, song.moods).join(", "),
                    song_title: song.title
                }));
            },
        },
        async created() {
            try {
                const res = await axios.get("/playlists/" + this.$route.params.id, {cache: {ignoreCache: false}});
                this.playlist = res.data.data;
                document.title = this.playlist.name;
                analyticsEvent("_sf_pageview");
            } catch (e) {
                await this.$router.push({name: "404"});
            }
        }
    };
</script>

<template>
    <div class="playlistSinglePage @pt-0 tablet:@pt-4 tablet-lg:@pt-10 desktop:@pt-12">
        <template v-if="playlist">
            <div class="@container @max-w-800">
                <div class="@flex @flex-wrap @items-center @pb-10 @-mx-5 tablet:@mx-0">
                    <div class="frameWrap tablet:@mx-auto desktop:@mx-0 @mb-6 tablet:@mb-4 desktop:@mb-0 @px-0">
                        <RoundImageWithDefault :image="playlist.image" not-round :alt="playlist.name"/>
                    </div>
                    <div class="@max-w-475 @mx-auto @w-full @text-center desktop:@text-left desktop:@pl-8 desktop:@m-0 tablet:@px-0 @px-5">
                        <h1 class="@mb-4">
                            {{playlist.name}}
                        </h1>
                        <div class="p2 @text-sfc-dark-grey" v-html="playlist.description"/>
                    </div>
                </div>
                <!--Songs-->
                <Playlist v-if="songs.length" class="desktop:@mt-20 @mb-26" :songs="songs"/>
            </div>
            <!--Similar-->
            <div class="@pt-16 tablet:@pt-20 @pb-26 @bg-sfc-light-beige">
                <h2 class="@container @text-center @mb-8 tablet:@mb-10">
                    Explore more playlists
                </h2>
                <div v-if="playlist.similarity && playlist.similarity?.length" class="@container playlistSimilarSlider @px-2.5">
                    <Slider :options="sliderOptions" :arrow-next-style="{top: '135px'}" :arrow-prev-style="{top: '135px'}">
                        <SplideSlide v-for="pl in playlist.similarity" :key="pl.playlist_id" class="slide @block @px-2.5 tablet:@px-4">
                            <router-link :to="{name: 'PlaylistSingle', params: {id: pl.playlist_id}}">
                                <RoundImageWithDefault :image="pl.playlist_image" not-round :alt="pl.playlist_name"/>
                                <h5 class="text @mt-4 l1 @text-center @text-sfc-black textUnderlineOnHover @mb-0">
                                    {{pl.playlist_name}}
                                </h5>
                            </router-link>
                        </SplideSlide>
                    </Slider>
                </div>
            </div>
        </template>
    </div>
</template>

<style scoped>
    .playlistSinglePage {
        .frameWrap {
            width: 100%;
            max-width: 340px;
            @screen desktop {
                max-width: 275px;
            }
            @screen mobile {
                max-width: initial;
            }
        }
    }
</style>
